module.exports = __webpack_public_path__ + "img/logo_GLF-white.eb9dcd2e.svg";